import { Center, RoundedBox, Text } from "@react-three/drei";
import { Interactive, useController } from "@react-three/xr";
import React from "react";
import { useCursorShrinkingStore } from "./CursorNew";
import { textMeshMaterial } from "../Popups/Open/XRImagePop";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

let timeout: NodeJS.Timeout;
let timeout2: NodeJS.Timeout;

const QuizButtonElement = (props: {
  fn: () => void;
  children: string;
  disabled?: boolean;
}) => {
  const cursor = useCursorShrinkingStore();

  const gaze = useController("none");

  const [hovering, setHovering] = React.useState<boolean>(false);

  const materialRef = React.useRef<THREE.MeshBasicMaterial>(null);

  useFrame(() => {
    if (props.disabled && materialRef.current) {
      materialRef.current.color.lerp(new THREE.Color("#aaa"), 0.1);
      materialRef.current.opacity = 0.5;
    } else if (hovering) {
      materialRef.current?.color.lerp(hoverColor, 0.1);
    } else materialRef.current?.color.lerp(baseColor, 0.1);
  });

  return (
    <Interactive
      onHover={() => {
        setHovering(true);
        if (props.disabled) {
          return;
        } else if (gaze) {
          cursor.setShrinking(false);
          setHovering(true);
          clearTimeout(timeout);
          clearTimeout(timeout2);

          timeout = setTimeout(() => {
            cursor.setShrinking(true);
            timeout2 = setTimeout(() => {
              cursor.setShrinking(false);
              clearTimeout(timeout);
              clearTimeout(timeout2);
              props.fn();
            }, 2e3);
          }, 1e3);
        }
      }}
      onBlur={() => {
        if (gaze) {
          cursor.setShrinking(false);
        }
        // cursor.setShrinking(false);
        clearTimeout(timeout);
        clearTimeout(timeout2);
        setHovering(false);
      }}
      onSelect={() => {
        if (props.disabled) {
          return;
        } else props.fn();
      }}
    >
      <Text
        fontWeight={700}
        renderOrder={4}
        position={[0, 0, 0.1]}
        material={textMeshMaterial}
      >
        {props.children}
      </Text>
      <RoundedBox
        renderOrder={3}
        name="answer"
        args={[8, 2]}
        radius={0.2}
        bevelSegments={0}
        smoothness={2}
      >
        <meshBasicMaterial transparent depthTest={false} ref={materialRef} />
      </RoundedBox>
    </Interactive>
  );
};

export default QuizButtonElement;

const baseColor = new THREE.Color("#0c4a6e");
const hoverColor = new THREE.Color("#1AA0ED");
const selectedcolor = new THREE.Color("#35a8e0");
